<template>
  <div class="finantial-settings-page">
    <!-- Back Button -->
    <div class="finantial-settings-page__header">
      <app-back-button
        v-if="showBackButton"
        :route-name="routeBack.name"
        :i18n-code="routeBack.i18nCode"
      />
      <!-- Buttons create -->
      <div
        v-for="tab in Object.values(tabs)"
        :key="tab.type"
        class="finantial-settings-page__header__buttons-create"
      >
        <!-- Show if has button create and connectedAccountId is loaded -->
        <router-link
          v-if="activeTabIndex === tab.index && tab.buttonCreate && tab.buttonCreate.enabled && connectedAccountId"
          :to="tab.buttonCreate.to"
        >
          <el-button type="primary">
            <span v-text="tab.buttonCreate.label" />
          </el-button>
        </router-link>
      </div>
    </div>

    <!-- Container -->
    <div 
      v-loading="loadingConnectedAccount"
      class="app-content-page app-content-page__settings finantial-settings-page__container"
    >
      <!-- Account page -->
      <div v-if="activeTabIndex === tabs.accounts.index && _subpropertyId">
        <finantial-settings-accounts-page
          :subproperty-id="_subpropertyId"
          :property-id="_propertyId"
          :subproperty-logo-url="_subpropertylLogoUrl"
          @refresh="() => findConnectedAccount({ disableLoading: true })"
        />
      </div>

      <!-- Payout Methods -->
      <div v-else-if="activeTabIndex === tabs.payoutMethods.index && connectedAccountId">
        <finantial-settings-payout-methods-page
          v-if="connectedAccountId"
          :subpropertyId="_subpropertyId"
          :propertyId="_propertyId"
          :connectedAccountId="connectedAccountId"
        />
      </div>

      <!-- Payout Shedule -->
      <div v-else-if="activeTabIndex === tabs.payoutSchedule.index">
        <finantial-settings-payout-schedule-page :prev-route="prevRoute" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { i18n } from '@shared/i18n';
import { get } from 'lodash';

import PriceListCard from '@modules/price/components/price-list-card.vue';
import PaymentOptionListCard from '@modules/payment-option/components/payment-option-list-card.vue';
import AccountsPage from '@modules/subproperty-settings/finantial-settings/finantial-settings-accounts/components/finantial-settings-accounts-page.vue';
import PayoutMethodsPage from '@modules/subproperty-settings/finantial-settings/finantial-settings-payout-methods/components/finantial-settings-payout-methods-page.vue';
import PayoutSchedulePage from '@modules/subproperty-settings/finantial-settings/finantial-settings-payout-schedule/components/finantial-settings-payout-schedule-page.vue';

export default {
  name: 'finantial-settings-page',

  props: {
    propertyId: {
      type: String,
      default: null,
    },
    subpropertyId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      usePropIds: false,
      prevRoute: null,
    }
  },

  computed: {
    ...mapGetters({
      subpropertyLogoUrl: 'paymentSettings/subpropertyLogoUrl',
      connectedAccount: 'paymentSettings/connectedAccount',
      subproperty: 'paymentSettings/subproperty',
      loadingConnectedAccount: 'paymentSettings/loadingConnectedAccount',
      isConnectedPersonEmpty: 'paymentSettings/isConnectedPersonEmpty',
      isPayoutMethodsEmpty: 'paymentSettings/isPayoutMethodsEmpty',
      currentManage: 'auth/manage/currentManage',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      isRootScreen: 'layout/isRootScreen',
    }),

    connectedAccountId() {
      return get(this, 'connectedAccount.id', null);
    },

    tabs() {
      return {
        accounts: {
          disabled: false,
          type: 'accounts',
          label: i18n(
            'subpropertySettings.finantial.accountTab',
          ),
          index: 0,
          routerPush: {
            name: 'finantialSettings',
            params: {
              tabType: 'accounts',
              propertyId: this._propertyId,
              subpropertyId: this._subpropertyId,
            },
          },
          buttonCreate: {
            enabled : !this.isConnectedPersonEmpty,
            label: i18n(
              'subpropertySettings.finantial.accounts.emptyPersonButton',
            ),
            to: {
              name: 'stripePersonCreate',
              params: {
                connectedAccountId: this.connectedAccountId,
              },
            },
          },
        },
        payoutMethods: {
          disabled: false,
          type: 'payoutMethods',
          label: i18n(
            'subpropertySettings.finantial.payoutMethodsTab',
          ),
          index: 1,
          routerPush: {
            name: 'finantialSettings',
            params: {
              tabType: 'payoutMethods',
              propertyId: this._propertyId,
              subpropertyId: this._subpropertyId,
            },
          },
          buttonCreate: {
            enabled : !this.isPayoutMethodsEmpty,
            label: i18n(
              'subpropertySettings.finantial.payoutMethods.emptyButton',
            ),
            to: {
              name: 'stripeExternalAccountCreate',
              params: {
                connectedAccountId: this.connectedAccountId,
              },
            },
          },
        },
        payoutSchedule: {
          disabled: false,
          type: 'payoutSchedule',
          label: i18n(
            'subpropertySettings.finantial.payoutScheduleTab',
          ),
          index: 2,
          routerPush: {
            name: 'finantialSettings',
            params: {
              tabType: 'payoutSchedule',
              propertyId: this._propertyId,
              subpropertyId: this._subpropertyId,
            },
          },
        },
      }
    },
    _subpropertyId() {
      if (this.usePropIds) return this.subpropertyId;
      return get(this, 'currentManage.subproperty.id', null);
    },
    _propertyId() {
      if (this.usePropIds) return this.propertyId;
      return get(this, 'currentManage.property.id', null);
    },
    _subpropertylLogoUrl() {
      if (this.subpropertyLogoUrl) {
        return this.subpropertyLogoUrl;
      } else if (get(this, 'currentManage.type', null) === 'subproperty') {
        return get(this, 'currentManage.subproperty.logo[0].publicUrl', null);
      } else {
        return null;
      }
    },
    showBackButton() {
      return this.currentManage.type === 'subproperty';
    },
    routeBack() {
      if (this.prevRoute && this.prevRoute.name === 'subproperty') {
        return  {
          name: 'home',
          params: null,
          i18nCode: 'home.nav.dashboard',
        }
      } else {
        return  {
          name: 'subpropertySettings',
          i18nCode: 'subpropertySettings.menu',
        }
      }
    },
  },

  async mounted() {
    await this.$nextTick()
    this.findConnectedAccount()
  },

  beforeDestroy() {
    this.doResetTabs();
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.usePropIds = !vm.isRootScreen
      vm.prevRoute = from
    })
  },

  methods: {
    ...mapActions({
      doFindConnectedAccount: 'paymentSettings/doFindConnectedAccount',
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
      doResetTabs: 'layout/headerTabs/doReset',
    }),
    parseActiveTab() {
      const routeTabType = this.$route.params.tabType;
      if (routeTabType) {
        this.setActiveTabIndex(this.tabs[routeTabType].index);
      } else {
        this.setActiveTabIndex(Object.values(this.tabs)[0].index);
      }
    },
    async findConnectedAccount({ disableLoading = false } = {}) {
      if (!this._subpropertyId) return this.$router.push({ name: 'home' })

      await this.doFindConnectedAccount({ subpropertyId: this._subpropertyId, disableLoading });
      this.parseActiveTab();

      if (!this.connectedAccountId) {
        const { payoutMethods, payoutSchedule } = this.tabs;
        payoutMethods.disabled = true;
        payoutSchedule.disabled = true;
        this.setActiveTabIndex(Object.values(this.tabs)[0].index)
      }

      if (!this.subproperty || !this.subproperty.paymentsEnabled) this.$router.push({ name: this.currentManage.type });
      else this.setTabs(Object.values(this.tabs).filter(({ disabled }) => !disabled ));
    },
  },

  components: {
    [PriceListCard.name]: PriceListCard,
    [PaymentOptionListCard.name]: PaymentOptionListCard,
    [AccountsPage.name]: AccountsPage,
    [PayoutMethodsPage.name]: PayoutMethodsPage,
    [PayoutSchedulePage.name]: PayoutSchedulePage,
  },

  watch: {
    activeTabIndex(tab, oldTab) {
      if (oldTab === null) return
      if (typeof tab !== 'number') return

      const tabName = Object.values(this.tabs).find(t => t.index === tab).type

      if (tabName === 'accounts') this.findConnectedAccount({ disableLoading: true })
    },
  },
};
</script>

<style lang="scss" scoped>
.finantial-settings-page {
  &__header {
    display: grid;
    grid-template-areas: 'back create';

    &__buttons-create {
      grid-area: create;
      justify-self: end;
    }
  }
  &__container {
    padding: 36px 36px;
  }
}
</style>


